export class VehicleAssociationObject {
    Id: number = 0;
    PolicyId: number;
    VehicleId: number;
    Active: boolean = true;
    Priority: number = null;
    GeofenceId: number = null;
    IsDeleted: boolean = false;
}

export class PolicyObject {
    Id: number = 0;
    PolicyName: string;
    Priority: number = 100;
    IsDeleted: boolean = false;

}

export class PolicyGeofenceObject {
    Id: number = 0;
    PolicyId: number;
    GeofenceId: number;
    IsDeleted: boolean = false;
}

export class RuleObject {
    Id: number = 0;
    PolicyId: number;
    Expression: string;
    ExpressionText: string;
    Action: number;
    Priority: number = 100;
    RuleType: string = null;
    EventTypeName: string;
    RuleViewState: number;
    IsDeleted: boolean = false;
    ExpressionList: any[] = [];
    ExpressionLogicalRelations: any[] = [];
    EventType: any = null;
}

export class RuleExpressionObject {
    Identifier: string;
    Operator: string;
    Value: string;
}



// WEBPACK FOOTER //
// D:/TFS/Softec.FMS-Core-Live/Source/Frontend/Web/Softec.FMS.Client.WebView-ng4/app/shared/dataModels/policies-tab-form.ts